import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface CloseTabModalProps {
  isOpen: boolean;
  designName: string;
  isLastTab: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const CloseTabModal: React.FC<CloseTabModalProps> = ({
  isOpen,
  designName,
  isLastTab,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onCancel}>
      <div 
        className="bg-slate-800 rounded-lg shadow-xl border border-slate-700 p-6 max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <AlertTriangle className="text-yellow-500" size={24} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-white mb-2">
              Close Design Tab
            </h3>
            <p className="text-sm text-slate-300 mb-4">
              {isLastTab ? (
                <>
                  This is the last open tab. Closing it will leave you with no active design.
                  Are you sure you want to close <span className="font-medium text-white">"{designName}"</span>?
                </>
              ) : (
                <>
                  Are you sure you want to close <span className="font-medium text-white">"{designName}"</span>?
                </>
              )}
            </p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={onCancel}
                className="px-4 py-2 text-sm font-medium text-slate-300 bg-slate-700 hover:bg-slate-600 rounded-md transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloseTabModal;
